export const CTA_URL_PATH = "/collections/strategy#contact";
